<template>
  <div>
    <div class="earning-detail__wrapper">
      <Heading :level="3" class="earning-detail__title">
        O que é rentabilidade?
      </Heading>
      <BaseText
        :color="nebraska.textSecondary"
        as="p"
        size="md"
        class="earning-detail__content"
      >
        A rentabilidade é o percentual de retorno da carteira desde o primeiro
        depósito. Em seu cálculo, movimentações como depósitos e resgates são
        desconsideradas, pois o método utilizado pondera o retorno pelo tempo e
        não por valores investidos.
      </BaseText>
      <a
        href="https://faq.warren.com.br/hc/pt-br/articles/360050310714-Como-%C3%A9-realizado-o-c%C3%A1lculo-de-rentabilidade-da-sua-carteira-"
        target="_blank"
        data-testid="faq-link-earning-calculation"
      >
        <Row>
          <template #top-left>
            <BaseText
              :color="nebraska.textPrimary"
              size="md"
              class="earning-detail__faq-link"
            >
              Entenda como é calculada
            </BaseText>
          </template>
          <template #top-right>
            <BaseIcon icon="ic_arrow_up_right" />
          </template>
        </Row>
      </a>
    </div>
    <div class="earning-detail__wrapper">
      <Heading :level="3" class="earning-detail__title">
        Rentabilidade x Rendimentos
      </Heading>
      <BaseText
        :color="nebraska.textSecondary"
        as="p"
        size="md"
        class="earning-detail__content"
      >
        Diferente da rentabilidade, o rendimento é o valor retornado sobre o
        investimento. Considerando a data e o valor do depósito, a rentabilidade
        pode ser positiva e o rendimento, em reais, negativo.
      </BaseText>
      <a
        href="https://faq.warren.com.br/hc/pt-br/articles/360022094514-Performance-x-Rentabilidade-como-funciona-"
        target="_blank"
        data-testid="faq-link-earning-versus-yield"
      >
        <Row has-interaction>
          <template #top-left>
            <BaseText
              :color="nebraska.textPrimary"
              size="md"
              class="earning-detail__faq-link"
            >
              Saiba mais
            </BaseText>
          </template>
          <template #top-right>
            <BaseIcon icon="ic_arrow_up_right" />
          </template>
        </Row>
      </a>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import { Row, Heading, BaseText, BaseIcon } from '@warrenbrasil/nebraska-web';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';

@Component({
  components: {
    Heading,
    Row,
    BaseText,
    BaseIcon
  }
})
export default class EarningDetail extends Vue {
  readonly nebraska = NebraskaColors;
}
</script>

<style lang="less" scoped>
.earning-detail {
  &__title {
    margin-bottom: 0;
    text-align: start;
  }

  &__wrapper {
    margin-bottom: @size-spacing-x600;
  }

  &__faq-link {
    text-decoration: none;
    font-weight: bold;
  }

  &__content {
    line-height: 26px;
    margin: @size-spacing-x350 0;
    text-align: start;
  }
}
</style>
